import React, { ChangeEvent, useState } from 'react';
import useValidateValue, { INVALID_CLASS } from '../../hooks/useValidateValue';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';
import styles from './AccountForm.module.scss';
import PasswordToolTip from './PasswordToolTip';

function Input(props: {
  type: string;
  name: string;
  value: string;
  label: string;
  placeholder: string;
  maxLength: number;
  handleInput: (event: ChangeEvent<HTMLInputElement>) => void;
  errorMessage: string;
}) {
  const {
    type, name, value, label, placeholder, maxLength, handleInput, errorMessage,
  } = props;
  const [showPasswordToolTip, setShowPasswordToolTip] = useState(false);
  // eslint-disable-next-line prefer-const
  let { validationClass, validateValue } = useValidateValue();
  const [hasBeenValidated, setHasBeenValidated] = useState(false);
  const { friend } = useFriendContext();
  const { isEmailUnique } = friend;
  function togglePasswordTooltip(showToolTip: boolean) {
    if (name === 'password') {
      setShowPasswordToolTip(showToolTip);
    }
  }

  if (!isEmailUnique && name === 'email') {
    validationClass = INVALID_CLASS;
  }

  return (
    <div className={styles.inputContainer}>
      {showPasswordToolTip && name === 'password' && <PasswordToolTip password={value} />}
      <label htmlFor={name} className={styles.label}>
        {label}
        <input
          type={type}
          className={`${styles.input} ${validationClass}`}
          value={value}
          name={name}
          placeholder={placeholder}
          maxLength={maxLength}
          onChange={(evt) => {
            handleInput(evt);
            if (hasBeenValidated) {
              validateValue(name, evt.target.value.trim());
            }
          }}
          onFocus={() => {
            togglePasswordTooltip(true);
          }}
          onBlur={(evt) => {
            togglePasswordTooltip(false);
            if (!hasBeenValidated) {
              setHasBeenValidated(true);
              validateValue(name, evt.target.value.trim());
            }
          }}
        />
        {validationClass === INVALID_CLASS
          ? <p className={styles.inputError}>{!isEmailUnique && name === 'email' ? 'This email has already been registered.' : errorMessage}</p>
          : <p className={styles.inputError}> </p>}
      </label>
    </div>
  );
}

export default Input;
